import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { FormConfigHttpClient } from './form-config-http.client';
import { FormConfigActions } from './form-config.store';

@Injectable({ providedIn: 'root' })
export class FormConfigEffects {
  public effect = createEffectFactory(FormConfigActions, this.actions$);

  public fetchFormConfigs$ = this.effect(FormConfigActions.fetchCollection, ({ payload }) =>
    this.formConfigHttpClient
      .fetch(payload!.scope)
      .pipe(map(formConfigs => ({ data: formConfigs, scope: payload!.scope }))),
  );

  constructor(
    private formConfigHttpClient: FormConfigHttpClient,
    private actions$: Actions,
  ) {}
}
